import styles from "./FileViewer.module.css";

const getExt = (value) => value.split(".").pop();

const getDisplayName = (file) => {
  if (file.type === "text") return `${file.name}.txt`;
  return `${file.name}.${getExt(file.value)}`;
};

const FileViewer = ({ file, onClose }) => {
  const isText = file.type === "text";

  return (
    <div
      className={`${styles.window} ${isText ? styles.textWindow : styles.imageWindow}`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.toolbar}>
        <div className={styles.trafficLights}>
          <button
            className={`${styles.dot} ${styles.close}`}
            onClick={onClose}
          />
          <button className={`${styles.dot} ${styles.minimize}`} />
          <button className={`${styles.dot} ${styles.zoom}`} />
        </div>
        <span className={styles.title}>{getDisplayName(file)}</span>
      </div>
      <div className={styles.content}>
        {isText ? (
          <pre className={styles.text}>{file.value}</pre>
        ) : (
          <img src={file.value} alt={file.name} className={styles.image} />
        )}
      </div>
    </div>
  );
};

export default FileViewer;
